import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import clsx from 'clsx';

import './style.css';

interface HeroPlaceholderProps {
  className?: string;
}

const HeroPlaceholder: React.FC<HeroPlaceholderProps> = ({ className }) => {
  return (
    <section
      id="hero"
      className={clsx('hero-section', className)}
    >
      <Container className='py-10 mt-15' style={{ minHeight: '400px' }}>
        <Row className="align-items-center">
          <Col lg={8} className="text-center text-lg-start">
            <div className="hero-content">
              {/* Title placeholder with skeleton loading effect */}
              <div className="placeholder-title placeholder-glow mb-3">
                <div className="placeholder bg-white bg-opacity-10 rounded" style={{ height: '24px', width: '200px' }}></div>
              </div>
              
              {/* Subtitle placeholder */}
              <div className="placeholder-subtitle placeholder-glow mb-4">
                <div className="placeholder bg-white bg-opacity-10 rounded" style={{ height: '48px', width: '100%', maxWidth: '500px' }}></div>
              </div>
              
              {/* Description placeholder */}
              <div className="placeholder-description placeholder-glow mb-5">
                <div className="placeholder bg-white bg-opacity-10 rounded mb-2" style={{ height: '20px', width: '100%', maxWidth: '600px' }}></div>
                <div className="placeholder bg-white bg-opacity-10 rounded" style={{ height: '20px', width: '80%', maxWidth: '500px' }}></div>
              </div>

              {/* Stats section placeholder */}
              <div className='d-flex flex-row gap-5 justify-content-center justify-content-lg-start mb-5'>
                {/* Alumni Unggulan placeholder */}
                <div className='d-flex flex-row gap-2'>
                  <div className='pt-2'>
                    <span className='d-flex justify-content-center align-items-center placeholder-icon placeholder-glow' style={{width: '40px', height: '40px', backgroundColor: 'rgba(240, 240, 240, 0.8)', borderRadius: '50%'}}>
                      <div className="placeholder bg-white bg-opacity-10 rounded" style={{width: '20px', height: '20px'}}></div>
                    </span>
                  </div>
                  <div className='d-flex flex-column justify-content-center m-0 placeholder-glow'>
                    <div className="placeholder placeholder-stat-number bg-white bg-opacity-10 rounded mb-1" style={{height: '32px', width: '60px'}}></div>
                    <div className="placeholder placeholder-stat-label bg-white bg-opacity-10 rounded" style={{height: '20px', width: '120px'}}></div>
                  </div>
                </div>

                {/* Negara Studi placeholder */}
                <div className='d-flex flex-row gap-2'>
                  <div className='pt-2'>
                    <span className='d-flex justify-content-center align-items-center placeholder-icon placeholder-glow' style={{width: '40px', height: '40px', backgroundColor: 'rgba(240, 240, 240, 0.8)', borderRadius: '50%'}}>
                      <div className="placeholder bg-white bg-opacity-10 rounded" style={{width: '20px', height: '20px'}}></div>
                    </span>
                  </div>
                  <div className='d-flex flex-column justify-content-center m-0 placeholder-glow'>
                    <div className="placeholder placeholder-stat-number bg-white bg-opacity-10 rounded mb-1" style={{height: '32px', width: '60px'}}></div>
                    <div className="placeholder placeholder-stat-label bg-white bg-opacity-10 rounded" style={{height: '20px', width: '120px'}}></div>
                  </div>
                </div>

                {/* Tingkat Keberhasilan placeholder */}
                <div className='d-flex flex-row gap-2'>
                  <div className='pt-2'>
                    <span className='d-flex justify-content-center align-items-center placeholder-icon placeholder-glow' style={{width: '40px', height: '40px', backgroundColor: 'rgba(240, 240, 240, 0.8)', borderRadius: '50%'}}>
                      <div className="placeholder bg-white bg-opacity-10 rounded" style={{width: '20px', height: '20px'}}></div>
                    </span>
                  </div>
                  <div className='d-flex flex-column justify-content-center m-0 placeholder-glow'>
                    <div className="placeholder placeholder-stat-number bg-white bg-opacity-10 rounded mb-1" style={{height: '32px', width: '60px'}}></div>
                    <div className="placeholder placeholder-stat-label bg-white bg-opacity-10 rounded" style={{height: '20px', width: '140px'}}></div>
                  </div>
                </div>
              </div>
              
              {/* Buttons placeholder */}
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start placeholder-glow">
                <div className="placeholder placeholder-button bg-white bg-opacity-10 rounded-5" style={{height: '48px', width: '160px'}}></div>
                <div className="placeholder placeholder-button bg-white bg-opacity-10 rounded" style={{height: '48px', width: '140px'}}></div>
              </div>
            </div>
          </Col>
          
          <Col lg={4} className="text-center">
            <div className="hero-image">
              {/* Hero image placeholder */}
              <div className="placeholder-image bg-white bg-opacity-10 rounded-3 p-5 placeholder-glow">
                <div className="placeholder bg-white bg-opacity-10 rounded mb-3" style={{height: '80px', width: '80px', margin: '0 auto'}}></div>
                <div className="placeholder bg-white bg-opacity-10 rounded" style={{height: '16px', width: '120px', margin: '0 auto'}}></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroPlaceholder;